import type { Metadata } from "@/lib/head";

import { PublicLayout } from "@/modules/landing/ui/public-header";
import { PLAN_SAME_FEATURES, PRICING_FAQ } from "@/modules/plan/copy";
import { PricingPlanCards } from "@/modules/plan/ui/plan-cards";
import { useSignedIn } from "@/pages/landing-session";
import { PRICING_LEAD, PRICING_TITLE } from "./pricing-state";

export const metadata: Metadata = {
  title: "요금제 — 지금은 무료로 모든 기능",
  description: "인테리어 시공사용 현장관리 buildpy(빌드파이) 요금제. 무료 요금제로 견적, 계약, 공사 사진과 일지, 시공사례까지 모든 기능을 씁니다. 더 큰 요금제는 준비 중입니다.",
};

export const PricingView = ({ signedIn }: { signedIn: boolean }) => (
  <PublicLayout signedIn={signedIn}>
    <div className="flex flex-col gap-10" data-testid="pricing-page">
      <div className="flex flex-col gap-3">
        <h1 className="text-3xl font-bold leading-snug tracking-tight md:text-5xl">{PRICING_TITLE}</h1>
        <p className="text-lg leading-relaxed text-secondary-foreground">{PRICING_LEAD}</p>
      </div>
      <PricingPlanCards signedIn={signedIn} />
      <p className="text-md text-muted-foreground">{PLAN_SAME_FEATURES}</p>
      <section className="flex max-w-3xl flex-col" data-testid="pricing-faq">
        <h2 className="text-2xl font-bold">자주 묻는 것</h2>
        <div className="mt-4 flex flex-col border-b border-border">
          {PRICING_FAQ.map((f) => (
            <details key={f.q} className="border-t border-border">
              <summary className="flex min-h-11 cursor-pointer items-center py-4 font-semibold">{f.q}</summary>
              <p className="pb-5 leading-relaxed text-secondary-foreground">{f.a}</p>
            </details>
          ))}
        </div>
      </section>
    </div>
  </PublicLayout>
);

// 요금제 — 무료 + 준비 중(Pro·Max, 가격 없음) · 로그인했으면 준비 중 버튼이 출시 알림 신청으로.
const PricingPage = () => <PricingView signedIn={useSignedIn()} />;

export default PricingPage;
